'use client'
import { MenuItem, Select } from '@mui/material'
import { FieldValue } from '@/types'
import { memo } from 'react'

type SelectFieldProps = {
  id: string
  value: FieldValue
  options: string[]
  onChangeHandler: (val: FieldValue, id: string) => void
}

const SelectField = ({ id, value, options, onChangeHandler }: SelectFieldProps) => {
  return (
    <Select value={value} size="small" onChange={(e) => onChangeHandler(e.target.value, id)} fullWidth>
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  )
}

export default memo(SelectField)
